import React from 'react';
import classnames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Clear from '@material-ui/icons/Clear';
import { Color } from 'swag-client-common/components/ui/color';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import PantonePickerIcon from '../pantone-picker-icon';
import appearAnimationClasses from '../../appear.anim.scss';
import classes from './colors-list.scss';
export default function ColorsList({
  colors,
  onColorRemove,
  onColorConvert,
  isConverted,
  hasColors,
  isConvertEnabled,
  isRemoveEnabled,
  isDisabled = false,
  isLoading = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, hasColors ? colors.map(pantoneColor => {
    const pantoneDetected = !!pantoneColor.hex;
    return /*#__PURE__*/React.createElement(CSSTransition, {
      key: pantoneColor.hex,
      timeout: 250,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement("div", {
      key: pantoneColor.hex,
      className: classes.colorRow
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.colorInfo
    }, pantoneDetected && /*#__PURE__*/React.createElement(Color, {
      color: pantoneColor.hex
      // @ts-ignore
      ,
      className: classes.color
    }), /*#__PURE__*/React.createElement("span", null, pantoneColor.pms)), /*#__PURE__*/React.createElement("div", {
      className: classes.icons
    }, isConvertEnabled && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.iconWrapper, {
        [classes.iconDisabled]: isLoading || isConverted
      }),
      "data-tooltip": 'Convert to this color'
    }, pantoneDetected && /*#__PURE__*/React.createElement("div", {
      "data-name": "convert-color",
      "data-color": pantoneColor.pms,
      onClick: () => onColorConvert(pantoneColor),
      className: classnames(classes.icon, classes.convertColorIcon),
      tabIndex: 0,
      "aria-label": `Convert color ${pantoneColor.pms}`,
      onKeyDown: e => handleOnEnterPressed(e, () => onColorConvert(pantoneColor))
    }, /*#__PURE__*/React.createElement(PantonePickerIcon, null))), isRemoveEnabled && !isDisabled && colors && colors.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.iconWrapper, {
        [classes.iconDisabled]: isLoading
      })
    }, /*#__PURE__*/React.createElement(Clear, {
      "data-name": "remove-color",
      "data-color": pantoneColor.pms,
      "data-tooltip": 'Remove color from print list',
      onClick: () => onColorRemove(pantoneColor.pms),
      className: classes.icon,
      tabIndex: 0,
      "aria-label": `Remove color for ${pantoneColor.pms}`,
      onKeyDown: e => handleOnEnterPressed(e, () => onColorRemove(pantoneColor.pms))
    })))));
  }) : null));
}